<p-table stripedRows [value]="items"
    dataKey="PostingType"
    #dtPostingType
    [scrollable]="true"
    scrollHeight="50vh"
    [style]="{ 'min-width': '100%' }"
    editMode="row"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>

    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Posting Type -->
            <th>
                Posting Type
                <p-sortIcon
                    pSortableColumn="Postingtype"
                    field="Postingtype"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Postingtype" display="menu" class="ml-auto" />
            </th>
            <!-- Posting Description -->
            <th>
                Posting Description
                <p-sortIcon
                    pSortableColumn="Postingtypedesc"
                    field="Postingtypedesc"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Postingtypedesc" display="menu" class="ml-auto" />
            </th>
            <!-- Account -->
            <th>
                Account
            </th>
            <!-- Posting Item -->
            <th [attr.title]="'Item used when transaction to be posted does not have an item'">
                Posting Item
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.PostingType }}"
        >
        <!-- Edit -->
            <td class="edit-cell">
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.PostingType ||
                            editing?.PostingType === item?.PostingType)
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    *ngIf="edit"
                    [disabled]="!item.ListID"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    >
                    </ef-status-icon>
                </div>
            </td>
            <!-- Posting Type -->
            <td
                class="disabled"
                data-toggle="tooltip"
                data-placement="top"
                [title]="item?.Name"
            >
                {{ item?.Name }}
            </td>
            <!-- Posting Description -->
            <td
                class="disabled"
                data-toggle="tooltip"
                data-placement="top"
                [title]="item?.Description"
            >
                {{ item?.Description }}
            </td>
            <!-- Account -->
            <td [attr.title]="(accounts | itemlookup: 'AccountListID':item?.ListID)?.AccountCode">
                <p-cellEditor>
                    <ng-template #input>
                        <div ngForm>
                            <p-select
                                [ngClass]="{
                                    'ng-invalid': !postingAccount.value
                                }"
                                [ngModelOptions]="{ standalone: true }"
                                #postingAccount
                                [required]="true"
                                [autoDisplayFirst]="false"
                                appendTo="body"
                                [options]="postingAccounts"
                                [filter]="true"
                                [(ngModel)]="item.ListID"
                            ></p-select>
                        </div>
                    </ng-template>
                    <ng-template #output>
                        {{
                            (
                                accounts
                                | itemlookup: 'AccountListID':item?.ListID
                            )?.AccountCode
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Posting Item -->
            <td>
                <p-cellEditor>
                    <ng-template #input>
                        <div ngForm>
                            <p-select
                                [ngModelOptions]="{ standalone: true }"
                                #postingItem
                                [required]="true"
                                [autoDisplayFirst]="false"
                                appendTo="body"
                                [options]="postingItems"
                                [filter]="true"
                                [(ngModel)]="item.Defaultitem"
                            ></p-select>
                        </div>
                    </ng-template>
                    <ng-template #output>
                        {{
                            (
                                postingItems
                                | itemlookup: 'value':item.Defaultitem
                            )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
</p-table>
